<template>
  <main class="main customer_shop_list" role="main">
    <div class="main_con" id="main_con">
      <div class="store">
        <div class="sort" v-if="headOption.visible">
          <ul>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'RECOMMAND_POINT' }"
              @click="closeShopFilterModal('RECOMMAND_POINT')"
            >
              <p>추천 순</p>
            </li>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'RESPONSE_RATE' }"
              @click="closeShopFilterModal('RESPONSE_RATE')"
            >
              <p>응답률 순</p>
            </li>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'CREATED_AT' }"
              @click="closeShopFilterModal('CREATED_AT')"
            >
              <p>신규매장 순</p>
            </li>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'CHAT_COUNT' }"
              @click="closeShopFilterModal('CHAT_COUNT')"
            >
              <p>상담건 순</p>
            </li>
            <li
              class="pnt"
              :class="{ on: filter.orderType == 'EVALUATION_SCORE' }"
              @click="closeShopFilterModal('EVALUATION_SCORE')"
            >
              <p>평점 순</p>
            </li>
          </ul>
        </div>
        <div class="store_list_wrap" v-if="isReload">
          <SkeletonStoreItem v-for="index in 5" :key="index" />
        </div>
        <div class="store_list_wrap" v-else>
          <Shop
            class="pnt"
            v-for="(shop, idx) in list"
            :store="shop"
            @toggle="toggleFollow(shop, shop.id, idx)"
            :key="idx"
            :shopInfo="getShopInfo(shop.id)"
            @goShopDetail="goShopDetail"
            :idx="idx"
            ref="shop"
            infinite-wrapper
          />
          <SkeletonStoreItem v-if="isScrolling && fetchCompleted" />
        </div>
      </div>
      <!-- <div class="store_new_est_wrap">
        <div class="store_new_est" @click="handleEstimate">
          <div class="store_new_est_img">
            <img src="@/assets/front/images/new/i_plus_w.svg" alt="" />
          </div>
          <button class="store_new_est_txt">요청서 작성하기</button>
        </div>
      </div> -->
      <template v-if="fetchCompleted && list.length === 0">
        <template v-if="filter.follow || filter.keyword">
          <div class="empty_wrap">
            <div class="empty result">
              <!--'기본: ', '준비중: ready', '결과없음: result'-->
              <div class="msg">
                <div>조건에 맞는 매장이 없습니다.</div>
                <br />
                <div>조건을 변경하여</div>
                <div>원하시는 매장을 찾아보세요.</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div>
            <img
              class="img none"
              src="@/assets/front/images/img_none.png"
              alt=""
            />
            <div class="msg" style="margin-bottom:20rem">
              <div>우리동네에 매장이 없다면 주변 번화가로 변경해 보세요.</div>
              <button class="btn bo" @click="gotoRegion">
                우리동네 변경하기
              </button>
            </div>
          </div>
        </template>
      </template>
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"> </span>
      </infinite-loading>
    </div>

    <DesignPopup
      @close="confirm"
      :show="designPopup"
      :data="popupParams"
    ></DesignPopup>
    <!-- <ShopDetail
      ref="shopDetail"
      @close="closeShopDetail"
      @shopFollowed="shopFollowed"
    /> -->
    <DesignPopup2
      :show="designPopup2"
      :data="{
        title: '동네 설정 안내',
        type: 'alert',
        msg: `동네 설정이 안되어 있습니다.<br />원활한 서비스를 위해 동네 설정 페이지로 이동합니다.`,
      }"
      @close="popupClose"
    />
  </main>
</template>

<script>
import Shop from '@/front/customer/views/shops/components/Shop.vue';
import { mapActions, mapState, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';
import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';
// import ShopDetail from '@common/components/modal/ShopDetail';
import { mapActions as reviewMapActions } from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';

import SkeletonStoreItem from '@common/components/shop/SkeletonItem/StoreItem.vue';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  name: 'Shop.List',
  components: {
    Shop,
    DesignPopup,
    InfiniteLoading,
    // ShopDetail,
    SkeletonStoreItem,
    DesignPopup2,
  },
  data() {
    return {
      shopIdx: 0,
      myDeviceName: '',
      myTelecomName: '',
      shopFilterModal: false,
      options: {
        // orderType: 'RESPONSE_RATE',
        orderType: 'RECOMMAND_POINT',
      },
      filter: {},
      designPopup: false,
      popupParams: {
        type: 'confirm',
        msg: '',
      },
      fetchCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      isReload: true,
      isScrolling: false,
      isShopDetail: false,
      visitPage: 1, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      designPopup2: false,
    };
  },
  async created() {
    await this.getDevice();
  },
  beforeCreated() {
    this.filter = this.options;
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  computed: {
    ...mapGetters({
      shops: shopTypes.SHOPS,
      shopInfo: shopTypes.SHOP,
      shopCnt: shopTypes.SHOP_COUNT,
    }),
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    headOption() {
      let str = '';
      let visible = false;
      if (this.shopCnt > 0 || this.filter.follow || this.filter.keyword) {
        visible = true;
      }
      return { headText: str, visible: visible };
    },
  },
  async mounted() {
    if (this.page == 1) {
      window.scrollTo(0, 0);
    }
    await this.fetchMe();
    this.filter = this.options;
    this.infiniteId++;
  },
  methods: {
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...mapActions([
      shopTypes.SHOP_UNFOLLOW,
      shopTypes.SHOP_FOLLOW,
      shopTypes.FETCH_SHOP,
      shopTypes.FETCH_SHOPS,
    ]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    ...userMapActions([
      userTypes.FETCH_ME,
      userTypes.UPDATE_USER_TELECOM_AND_DEVICE,
    ]),
    ...reviewMapActions([
      reviewTypes.FETCH_REVIEWS,
      reviewTypes.FETCH_REVIEW_CHECK,
    ]),
    openShopFilterModal(type) {
      this.shopFilterModal = true;
    },
    handleEstimate() {
      this.$router.push({ name: 'Estimation.Form' });
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (fromName == 'Shops.Detail') {
        let visit_page = localStorage.getItem('visit_shop_list');

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;
          this.options.orderType = visit_page.filter;
          this.filter = this.options;
          this.size = (visit_page.page - 1) * 10;

          // 데이터 담고 삭제
          localStorage.removeItem('visit_shop_list');
        }
      }
    },
    async fetchMe() {
      await this[userTypes.FETCH_ME]();
      if (this.user.emdAreaName == null || this.user.emdAreaName == '') {
        this.designPopup2 = true;
      }
      console.log('this.userthis.userthis.user');
      console.log(this.user);
    },
    popupClose() {
      this.designPopup2 = false;

      this.$router.push({
        name: 'Auth.Region',
        query: { from: 'Main' },
      });
    },
    async getDevice() {
      nativeDeviceInfo();
      await sleep(800);
      this.myDeviceName = window.$bridge.deviceModelName || '';
      this.myTelecomName = window.$bridge.telecomName || '';

      // 로그인 후 디바이스 정보 저장
      // if (this.myDeviceName != '' || this.myTelecomName != '') {
      //   let td_param = {
      //     id: this.user.id,
      //     deviceModelName: this.myDeviceName,
      //     telecomName: this.myTelecomName,
      //   };
      //   this[userTypes.UPDATE_USER_TELECOM_DEVICE](td_param);
      // }

      if (this.myDeviceName != '' || this.myTelecomName != '') {
        let td_param = {
          id: this.user.id,
          deviceName: this.myDeviceName,
          deviceModelName: '',
          telecomName: this.myTelecomName,
        };
        this[userTypes.UPDATE_USER_TELECOM_AND_DEVICE](td_param);
      }
    },
    gotoRegion() {
      let codeType = 'e';
      let areaId = this.user.emdAreaId;
      if (this.user.admName) {
        const admArea = JSON.parse(this.user.admName);
        areaId = admArea.id;
        codeType = 'a';
      }
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          //areaName: this.user.emdAreaName.split(' ')[2],
          areaName: this.user.emdAreaName.substring(
            this.user.emdAreaName.lastIndexOf(' ') + 1,
          ),
          areaFullName: this.user.emdAreaName,
          areaId,
          codeType,
          from: 'ShopList',
        },
      });
    },
    gotoSearch() {
      this.$router.push({
        name: 'Shops.search',
        query: { searchText: '' },
      });
    },
    async getShopInfo(id) {
      //await this[shopTypes.FETCH_SHOPS](id);
    },

    closeShopFilterModal(orderType) {
      this.options.orderType = orderType;
      this.filter = this.options;
      this.shopFilterModal = false;
      this.isReload = true;

      // 세션 정보 초기화
      this.visitPage = 0;
      this.scrollLocation = 0;

      this.getListPageOne();
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
      this.list = [];
    },
    // async infiniteHandler($state) {
    //   this.isScrolling = true;
    //   if (this.infiniteId == 0) {
    //     $state.complete();
    //   } else {
    //     await this.getList();
    //     this.direction = 'bottom';
    //     this.size = 10;
    //     this.$nextTick(() => {
    //       if (this.shops.content.length) {
    //         this.list.push(...this.shops.content);
    //         this.page += 1;
    //         $state.loaded();
    //         this.isReload = false;
    //         this.isScrolling = false;
    //         // 상세 -> 리스트로 돌아왔을때 저장된 스크롤 위치로 보내주기
    //         setTimeout(() => {
    //           if (this.visitPage >= this.page) {
    //             window.scrollTo(0, this.scrollLocation);
    //             this.page = this.visitPage;
    //           }
    //         }, 10);
    //       } else {
    //         $state.complete();
    //         this.isReload = false;
    //         this.isScrolling = false;
    //       }
    //     });
    //   }
    // },
    async infiniteHandler($state) {
      const target = document.querySelector('#main_con');
      this.isScrolling = true;
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getList();

        this.size = 10;
        this.$nextTick(() => {
          if (this.shops.content.length) {
            this.list.push(...this.shops.content);
            this.page += 1;
            $state.loaded();
            this.isReload = false;
            this.isScrolling = false;
            // 상세 -> 리스트로 돌아왔을때 저장된 스크롤 위치로 보내주기
            setTimeout(() => {
              if (this.visitPage >= this.page) {
                target.scrollTo(0, this.scrollLocation);
                this.page = this.visitPage;
              }
            }, 10);
          } else {
            $state.complete();
            this.isReload = false;
            this.isScrolling = false;
          }
        });
      }
    },
    refresh() {
      this.filter = this.options;
      this.getListPageOne();
    },
    async goShopDetail(shopId) {
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      const target = document.querySelector('#main_con');

      let scrollLocation = target.scrollTop; // 현재 스크롤바 위치
      const visit_page = {
        page: this.page,
        scrollLocation: scrollLocation,
        filter: this.options.orderType,
      };

      localStorage.setItem('visit_shop_list', JSON.stringify(visit_page));
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝

      this.isShopDetail = true;
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: shopId,
        },
      });
    },
    async shopFollowed(shopInfo) {
      this.$refs.shop[this.shopIdx].store.followed = shopInfo.followed;
    },
    async getList() {
      let params = {
        orderType: this.filter.orderType,
        page: this.page,
        size: this.size,
        isLoading: false,
      };
      if (this.filter.keyword) {
        params['keywordId'] = this.filter.keyword.id;
      }
      if (this.filter.follow) {
        params['follow'] = this.filter.follow;
      }
      await this[shopTypes.FETCH_SHOPS](params);
      this.fetchCompleted = true;
    },
    async toggleFollow(shop, id, idx) {
      const self = this;
      const funAutoEstimationInProgress = async () => {
        await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
          userId: self.currentUser.id,
          storeId: id,
        });
      };
      const funToggle = async function() {
        await self[
          shop.followed ? shopTypes.SHOP_UNFOLLOW : shopTypes.SHOP_FOLLOW
        ]({ id: id });
        //self.refresh();
        //페이지 중간에 새로고침하면 문제가 되니 관심매장체크만 변경해줘야함.
        // console.log(self.list, idx);
        self.list[idx].followed = !self.list[idx].followed;
      };
      if (shop.followed) {
        // 자동견적서 체크.
        await funAutoEstimationInProgress();
        if (self.autoEstimation.id) {
          self[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message:
              '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
            okCb: async () => {
              await funToggle();
              //this.$router.go(-1);
            },
          });
        } else {
          await funToggle();
        }
      } else {
        await funToggle();
      }
    },
    confirm() {},
  },
};
</script>
